import { useEffect, useRef } from "react";
import { Alert, Modal, Spinner } from "react-bootstrap";
import useQuickTableReservation from "./useQuickTableReservation";
import "./QuickTableReservationModal.css";
export default function QuickTableReservationModal({ selection, token, onClose, onHandoff, onRequireLogin }) {
  const flow = useQuickTableReservation({ selection, token, onHandoff, onRequireLogin });
  const statusRef = useRef(null);
  useEffect(() => { if (flow.notice) statusRef.current?.focus(); }, [flow.notice]);
  if (!selection) return null;
  const max = selection.bar.maxPartySize || 20;
  const close = () => {
    onClose?.();
    if (selection.invoker?.isConnected) selection.invoker.focus();
  };
  const ready = flow.status === "ready";
  const holding = flow.status === "holding" || flow.status === "handoff";
  return <Modal show onHide={close} centered aria-labelledby="quick-table-title" className="quick-table-modal">
    <Modal.Header closeButton closeLabel="Cerrar">
      <Modal.Title id="quick-table-title">Reservar en {selection.bar.name}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="quick-table-context">{selection.date} · {selection.slot.slotStart} a {selection.slot.slotEnd}</p>
      <label htmlFor="quick-party">Cantidad de personas</label>
      <input id="quick-party" className="form-control" type="number" min="1" max={max} autoFocus
        value={flow.partyInput} aria-invalid={!flow.party.valid} aria-describedby="quick-party-help"
        onChange={(event) => flow.setPartyInput(event.target.value)} />
      {!flow.party.valid && <p id="quick-party-help" className="quick-table-validation">Ingresá entre 1 y {max} personas.</p>}
      <div className="quick-table-status" aria-live="polite">
        {flow.notice && <Alert variant="danger" role="alert" tabIndex="-1" ref={statusRef}>{flow.notice}</Alert>}
        {flow.status === "loading" && <div><Spinner animation="border" size="sm" /> Validando disponibilidad…</div>}
        {flow.status === "error" && <button type="button" className="btn btn-outline-primary" onClick={flow.load}>Reintentar</button>}
        {ready && flow.party.valid && flow.zones.length === 0 && <p>No hay sectores disponibles para esta cantidad de personas.</p>}
      </div>
      {ready && flow.zones.length > 0 && <fieldset className="quick-table-zones">
        <legend>Elegí un sector</legend>
        {flow.zones.map((zone) => <label key={zone.name}>
          <input type="radio" name="quick-zone" value={zone.name} checked={flow.selectedZone === zone.name}
            onChange={() => flow.setSelectedZone(zone.name)} />
          <span>{zone.name} · {zone.priceLabel}</span>
        </label>)}
      </fieldset>}
    </Modal.Body>
    <Modal.Footer>
      <button type="button" className="btn btn-outline-primary" onClick={close}>Cancelar</button>
      <button type="button" className="r-btn-primary" disabled={!ready || !flow.party.valid || !flow.selectedZone || holding}
        onClick={flow.confirm}>{holding ? "Procesando reserva" : "Continuar a la reserva"}</button>
    </Modal.Footer>
  </Modal>;
}
